import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./White_Btn.css";

const White_Btn = ({ btnText, type, onClick }) => {
  return (
    <button
      className="White_Btn"
      type={type ? type : "button"}
      onClick={onClick}
    >
      <p className="btn_text">{btnText}</p>
    </button>
  );
};

export default White_Btn;
